import React, { useEffect, useState } from 'react'
import { AboutUsHeader, CoreValues, CTA, Employees, Footer, Header, Loader } from '../components'

const AboutUs = () => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate the loading delay
    const timer =setTimeout(() => {
      setIsLoading(false); // After 2 seconds, set loading to false
    }, 2000);

    return () => clearTimeout(timer); // Clean up the timer on component unmount
  }, []);


  return (
    <>
      {/* The header */}
      <Header />

      {/* The spaces between the header and the body */}
      <br/><br/>

      {/* The About-Us body */}
      <div
        style={{
          background: 'linear-gradient(135deg, #117 50%, #28313f 50%',
          minHeight: '100vh', // Ensure it takes full height
          paddingTop: '40px',
          paddingBottom: '40px'
        }}
      >
        {isLoading ? (
          <Loader /> // SHow loader while the page is loading
        ) : (
          <div style={{ padding: ' 0 20px' }}> {/* Adding side padding */}
            <br/><br/>
            <AboutUsHeader /><br/>
            <Employees /><br/>
            <CoreValues /><br/>
            <br/>
            <CTA /><br/>
          </div>
        )}
      </div>

      {/* the footer */}
      <Footer />
    </>
  )
}

export default AboutUs